import AbstractForecastColumnTemplate from "./AbstractForecastColumnTemplate.js";
import PredictedForecastColumn from "../instance/PredictedForecastColumn.js";

/**
 * `PredictedForecastColumnTemplate` is the editable reference of the concrete
 * PredictedForecastColumn, which specifies how to compute the period prediction
 * when interpreting a forecasting template.
 *
 * @param {MonthPeriod} start - The forecast period to which the
 *   column is associated
 */
export default class PredictedForecastColumnTemplate extends AbstractForecastColumnTemplate {
	accept(visitor) {
		return visitor.visitPredictedForecastColumnTemplate(this);
	}

	isPredictedForecastColumnTemplate() {
		return true;
	}

	_instanceClass() {
		return PredictedForecastColumn;
	}

	static getType() {
		return "PredictedForecastColumnTemplate";
	}
}
